import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PayLinkPage } from "@/features/public/pay-link";
import { maskSearchFragment } from "@/features/shared/route-masking";

/**
 * The Birdwatch pay page (phase-2-deposits.md Step 26 item 5): a deposit
 * payment request's link, `/pay/<token>`, no login.
 *
 * `payment_intent` is set when Stripe sends the payer back from the bank's
 * approval step; the page completes that payment once and removes it with
 * Stripe's other redirect keys. Lenient, so a malformed value never crashes
 * the page, and the client secret is never declared here. The tab title never
 * carries the token.
 */
const searchSchema = z.object({
  payment_intent: z.string().optional().catch(undefined),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/(pay)/pay/$token")({
  validateSearch: searchSchema,
  component: PayLinkPage,
  head: () => ({
    meta: [{ title: "Birdwatch - Pay deposit" }],
  }),
});
